import { render, staticRenderFns } from "./team-extra-data.vue?vue&type=template&id=6aa8fa4c&scoped=true&"
import script from "./team-extra-data.vue?vue&type=script&lang=js&"
export * from "./team-extra-data.vue?vue&type=script&lang=js&"
import style0 from "./team-extra-data.vue?vue&type=style&index=0&id=6aa8fa4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8fa4c",
  null
  
)

export default component.exports